import { resources } from '../locales/resources';

type Locale = keyof typeof resources;

export function getContactSlug(locale: Locale): string {
  return resources[locale].translation.contact.slug;
}

export function isContactSlug(slug: string): boolean {
  return (Object.keys(resources) as Locale[]).some(
    (locale) => getContactSlug(locale) === slug,
  );
}

export function resolveContactSlug(slug: string, locale: Locale): string {
  if (isContactSlug(slug)) {
    return getContactSlug(locale);
  }

  return slug;
}
